<app-navbar-style-two></app-navbar-style-two>


<!-- <div class="reset-card">
    <div class="text-center mb-4">
        <img src="assets/img/logo.svg" class="img-fluid logo_login" alt="Logo">

        <h2 class="mt-4 mb-2">Reset Password</h2>
        <p class="text-muted">
            Create a new secure password for your account
        </p>
    </div>

 <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
          <div class="mx-auto mw-450">
            <div class="text-center mb-4">
                       <img src="assets/img/logo.svg" class="img-fluid logo_login" alt="Logo">
                   </div>
  
            <div class="form-wrap">
              <label>New Password</label>
              <input type="password" formControlName="password" class="form-control" />
              <div *ngIf="resetForm.get('password')?.touched && resetForm.get('password')?.errors as passwordErrors" class="text-danger mt-1">
                <div *ngIf="passwordErrors['required']">Password is required.</div>
                <div *ngIf="passwordErrors['pattern']">
                  Must be at least 10 characters, include uppercase, lowercase, number and special character.
                </div>
              </div>
            </div>
  
            <div class="form-wrap">
              <label>Confirm New Password</label>
              <input type="password" formControlName="confirmPassword" class="form-control" />
              <div *ngIf="resetForm.get('confirmPassword')?.touched && resetForm.get('confirmPassword')?.errors as confirmErrors" class="text-danger mt-1">
                <div *ngIf="confirmErrors['required']">Confirm password is required.</div>
                <div *ngIf="confirmErrors['mismatch']">Passwords do not match.</div>
              </div>
            </div>
  
            <div *ngIf="message" class="alert" [ngClass]="{'alert-success': status === 1, 'alert-danger': status === 2}">
              {{ message }}
            </div>
  
            <div class="form-wrap">
                <button type="submit" class="btn btn-primary" [disabled]="isLoading || resetForm.invalid">
                  <ng-container *ngIf="!isLoading; else loadingTemplate">
                    Change Password
                  </ng-container>
                  <ng-template #loadingTemplate>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                  </ng-template>
                </button>
              </div>              
  
            <div class="mb-3 text-center">
              <h6>Return to <a  class="text-purple link-hover">Login</a></h6>
            </div>
  
            <div class="text-center">
              <p class="fw-medium text-gray">Copyright &copy; 2025 - ERP</p>
            </div>
          </div>
        </form>



</div>

<div class="w-50 d-none d-lg-flex align-items-center justify-content-center">
    <img
        src="assets/img/reset-password.svg"
        class="img-fluid"
        style="max-width: 500px;"
        alt="Reset Password">
</div> -->

  



<!-- AUTH SECTION -->
<div class="p-4 bg-dark" style="margin-top: -90px;"></div>
<section class="profile-authentication-area ptb-100">

    <div class="container">

        <div class="auth-wrapper">

            <!-- LEFT SIDE -->
            <div class="auth-left">

                <div class="auth-content">

                    <span class="welcome-badge">
                        Welcome To
                    </span>

                    <h2 style="color:#ff6b35">
                        Sangeetha Toys
                    </h2>

                    <p>
                        Experience authentic flavors with seamless ordering,
                        fast delivery and delicious meals prepared with love.
                    </p>

                    <ul class="auth-features">

                        <li>
                            <i class='bx bx-check-circle'></i>
                            Easy online ordering
                        </li>

                        <li>
                            <i class='bx bx-check-circle'></i>
                            Fresh & hygienic food
                        </li>

                        <li>
                            <i class='bx bx-check-circle'></i>
                            Fast doorstep delivery
                        </li>

                    </ul>

                </div>

            </div>

            <!-- RIGHT SIDE -->
            <div class="auth-right">

                <!-- TABS -->
                <!-- <div class="auth-tabs">

                    <button type="button" [class.active]="activeTab === 'login'" (click)="activeTab = 'login'">

                        Login

                    </button>

                    <button type="button" [class.active]="activeTab === 'register'" (click)="activeTab = 'register'">

                        Register

                    </button>

                </div> -->

                <!-- <div class="auth-tabs">

                  
                    <button *ngIf="activeTab === 'register'" type="button" class="active" (click)="activeTab = 'login'">

                        Login

                    </button>

                  
                    <button *ngIf="activeTab === 'login'" type="button" class="active" (click)="activeTab = 'register'">

                        Register

                    </button>

                </div> -->

                <!-- FORGOT PASSWORD FORM -->
                <div class="auth-form" >

                    <!-- <h2>Forgot Password</h2>

                    <p class="auth-subtitle">
                        Enter your email address and we'll send you a password reset link.
                    </p> -->

                    <!-- <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()">

                        <div class="form-group">

                            <label>Email Address</label>

                            <input type="email" class="form-control" formControlName="email"
                                placeholder="Enter your email">

                            <div class="validation-error" *ngIf="forgotPasswordForm.get('email')?.touched &&
                        forgotPasswordForm.get('email')?.invalid">

                                <small *ngIf="forgotPasswordForm.get('email')?.errors?.['required']">
                                    Email is required.
                                </small>

                                <small *ngIf="forgotPasswordForm.get('email')?.errors?.['email']">
                                    Enter a valid email.
                                </small>

                            </div>

                        </div>

                        <button type="submit" class="auth-btn" [disabled]="forgotPasswordForm.invalid">

                            Send Reset Link

                        </button>

                        <div class="switch-auth-text">

                            <a href="javascript:void(0)" (click)="activeTab = 'login'">

                                Back To Login

                            </a>

                        </div>

                    </form> -->



                        <div class="text-center mb-4">
        <!-- <img src="assets/img/logo.svg" class="img-fluid logo_login" alt="Logo"> -->

        <h2 class="mt-4 mb-2">Reset Password</h2>
        <p class="text-muted">
            Create a new secure password for your account
        </p>
    </div>

 <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
          <div class="mx-auto mw-450">
            <div class="text-center mb-4">
                       <!-- <img src="assets/img/logo.svg" class="img-fluid logo_login" alt="Logo"> -->
                   </div>
  
            <div class="form-wrap">
              <label>New Password</label>
              <input type="password" formControlName="password" class="form-control" />
              <div *ngIf="resetForm.get('password')?.touched && resetForm.get('password')?.errors as passwordErrors" class="text-danger mt-1">
                <div *ngIf="passwordErrors['required']">Password is required.</div>
                <div *ngIf="passwordErrors['pattern']">
                  Must be at least 10 characters, include uppercase, lowercase, number and special character.
                </div>
              </div>
            </div>
  
            <div class="form-wrap">
              <label>Confirm New Password</label>
              <input type="password" formControlName="confirmPassword" class="form-control" />
              <div *ngIf="resetForm.get('confirmPassword')?.touched && resetForm.get('confirmPassword')?.errors as confirmErrors" class="text-danger mt-1">
                <div *ngIf="confirmErrors['required']">Confirm password is required.</div>
                <div *ngIf="confirmErrors['mismatch']">Passwords do not match.</div>
              </div>
            </div>
  
            <div *ngIf="message" class="alert" [ngClass]="{'alert-success': status === 1, 'alert-danger': status === 2}">
              {{ message }}
            </div>
  
            <div class="form-wrap">
                <button type="submit" class="btn btn-primary" [disabled]="isLoading || resetForm.invalid">
                  <ng-container *ngIf="!isLoading; else loadingTemplate">
                    Change Password
                  </ng-container>
                  <ng-template #loadingTemplate>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                  </ng-template>
                </button>
              </div>              
  
            <div class="mb-3 text-center">
              <h6>Return to <a  class="text-purple link-hover">Login</a></h6>
            </div>
  
            <div class="text-center">
              <p class="fw-medium text-gray">Copyright &copy; 2025 - ERP</p>
            </div>
          </div>
        </form>





                </div>
          
          
          
            </div>

        </div>

    </div>

</section>